import { Box, styled, type CSSObject } from '@mui/material';

export const InfoSectionRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** 전자결재 본문 묶음(소제목 단위) 사이 여백 — 작성·조회 공통 */
export const APPROVAL_SECTION_GAP = 32;

/** 가이드·AI 업로더처럼 무거운 덩어리 바로 아래 여백 — 일반 간격이면 아래 블록과 붙어 보임 */
export const APPROVAL_SECTION_GAP_LG = 48;

/** 전자결재 본문 소제목 글자 — 모든 양식 공통(16px). 저장 HTML 클래스에도 이 값을 씀 */
export const infoSectionTitleStyles: CSSObject = {
  fontFamily: 'Pretendard, sans-serif',
  fontSize: 16,
  fontWeight: 600,
  lineHeight: '24px',
  color: 'var(--dk-text, #131313)',
};

/** 조회 본문 섹션 제목 — 「신청자 정보」「신청 내용」「취소할 품의」 류 */
export const InfoSectionTitle = styled('h3')({
  margin: 0,
  ...infoSectionTitleStyles,
});
